import React from "react";
import styles from "./gigRequest.module.css";
import {
    createFormField,
    createSelectorField,
    createDateTimeField,
} from "../formfield/sharedFormFields";

interface FormFieldProps {
    label: string;
    icon?: React.ReactNode;
    error?: string;
    children: React.ReactNode;
}

export const FormField = createFormField({
    formGroup: styles.formGroup,
    labelWrapper: styles.labelWrapper,
    label: styles.label,
    errorMessage: styles.errorMessage,
}) as React.FC<FormFieldProps>;

export const SelectorField = createSelectorField(
    FormField,
    {
        selectSx: {
            height: "auto",
            minHeight: "2.75rem",
            borderRadius: "calc(var(--radius) - 0.125rem)",
            border: "var(--color-border)",
            '& .MuiSelect-select': {
                paddingTop: '8px',
                paddingBottom: '8px',
            },
            '& .MuiOutlinedInput-notchedOutline': {
                borderColor: 'rgba(0, 0, 0, 0.23)',
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: 'rgba(0, 0, 0, 0.23)',
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderColor: 'rgba(0, 0, 0, 0.23)',
                borderWidth: '1px',
            },
        },
        menuPropsSx: {
            maxHeight: 300,
            '& .MuiMenuItem-root': {
                minHeight: '36px',
                paddingTop: '6px',
                paddingBottom: '6px',
            },
            '& .MuiMenuItem-root.Mui-selected': {
                backgroundColor: 'rgba(0, 0, 0, 0.08)',
                '&:hover': {
                    backgroundColor: 'rgba(0, 0, 0, 0.12)',
                },
            },
            '& .MuiMenuItem-root:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.04)',
            },
        },
        muiSelectorSx: {
            height: "2.75rem",
            borderRadius: "calc(var(--radius) - 0.125rem)",
            border: " var(--color-border)",
        },
        placeholderStyle: { color: '#999' },
    },
    true,
);

export const DateTimeField = createDateTimeField({
    formGroup: styles.formGroup,
    timeHeaderWrapper: styles.timeHeaderWrapper,
    labelWrapper: styles.labelWrapper,
    label: styles.label,
    errorMessage: styles.errorMessage,
});
